import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { AuthGate } from "./components/AuthGate";
import { AccessRoute, RoleHome } from "./components/AccessRoute";
import { DashboardPage } from "./pages/DashboardPage";

const ApartmentsPage = lazy(() =>
  import("./pages/ApartmentsPage").then((module) => ({ default: module.ApartmentsPage })),
);
const BookingsPage = lazy(() =>
  import("./pages/BookingsPage").then((module) => ({ default: module.BookingsPage })),
);
const CalendarPage = lazy(() =>
  import("./pages/CalendarPage").then((module) => ({ default: module.CalendarPage })),
);
const GuestsPage = lazy(() =>
  import("./pages/GuestsPage").then((module) => ({ default: module.GuestsPage })),
);
const CheckInOutPage = lazy(() =>
  import("./pages/CheckInOutPage").then((module) => ({ default: module.CheckInOutPage })),
);
const CleaningPage = lazy(() =>
  import("./pages/CleaningPage").then((module) => ({ default: module.CleaningPage })),
);
const RoomServicePage = lazy(() =>
  import("./pages/RoomServicePage").then((module) => ({ default: module.RoomServicePage })),
);
const PaymentsPage = lazy(() =>
  import("./pages/PaymentsPage").then((module) => ({ default: module.PaymentsPage })),
);
const ShiftPage = lazy(() => import("./pages/ShiftPage").then((module) => ({ default: module.ShiftPage })));
const ReportsPage = lazy(() => import("./pages/ReportsPage").then((module) => ({ default: module.ReportsPage })));
const EmployeesPage = lazy(() => import("./pages/EmployeesPage").then((module) => ({ default: module.EmployeesPage })));
const SettingsPage = lazy(() => import("./pages/SettingsPage").then((module) => ({ default: module.SettingsPage })));
const AcceptInvitationPage = lazy(() => import("./pages/AcceptInvitationPage").then((module) => ({ default: module.AcceptInvitationPage })));
const GuestQrPage = lazy(() => import("./pages/GuestQrPage").then((module) => ({ default: module.GuestQrPage })));
const ModulePlaceholder = lazy(() =>
  import("./pages/ModulePlaceholder").then((module) => ({ default: module.ModulePlaceholder })),
);

export function App() {
  return (
    <Routes>
      <Route path="/invite" element={<Suspense fallback={<PageLoader />}><AcceptInvitationPage /></Suspense>} />
      <Route path="/guest/:token" element={<Suspense fallback={<PageLoader />}><GuestQrPage /></Suspense>} />
      <Route path="/*" element={<AuthGate><ProtectedRoutes /></AuthGate>} />
    </Routes>
  );
}

function ProtectedRoutes() {
  return <Routes>
      <Route element={<AppShell />}>
        <Route index element={<RoleHome />} />
        <Route path="/dashboard" element={<AccessRoute permission={["bookings.manage", "stays.manage", "apartments.manage"]}><DashboardPage /></AccessRoute>} />
        <Route
          path="/apartments"
          element={<AccessRoute permission="apartments.manage"><Suspense fallback={<PageLoader />}><ApartmentsPage /></Suspense></AccessRoute>}
        />
        <Route path="/qr-codes" element={<Navigate to="/settings?tab=qr" replace />} />
        <Route path="/bookings" element={<AccessRoute permission="bookings.manage"><Suspense fallback={<PageLoader />}><BookingsPage /></Suspense></AccessRoute>} />
        <Route path="/calendar" element={<AccessRoute permission="bookings.manage"><Suspense fallback={<PageLoader />}><CalendarPage /></Suspense></AccessRoute>} />
        <Route path="/guests" element={<AccessRoute permission="guests.manage"><Suspense fallback={<PageLoader />}><GuestsPage /></Suspense></AccessRoute>} />
        <Route path="/checkinout" element={<AccessRoute permission="stays.manage"><Suspense fallback={<PageLoader />}><CheckInOutPage /></Suspense></AccessRoute>} />
        <Route path="/shift" element={<AccessRoute permission="cash.expenses.manage"><Suspense fallback={<PageLoader />}><ShiftPage /></Suspense></AccessRoute>} />
        <Route path="/cleaning" element={<AccessRoute permission={["housekeeping.manage", "housekeeping.work"]}><Suspense fallback={<PageLoader />}><CleaningPage /></Suspense></AccessRoute>} />
        <Route path="/room-service" element={<AccessRoute permission={["room_service.manage", "room_service.work"]}><Suspense fallback={<PageLoader />}><RoomServicePage /></Suspense></AccessRoute>} />
        <Route path="/payments" element={<AccessRoute permission={["payments.manage", "payments.collect"]}><Suspense fallback={<PageLoader />}><PaymentsPage /></Suspense></AccessRoute>} />
        <Route path="/reports" element={<AccessRoute permission="reports.view"><Suspense fallback={<PageLoader />}><ReportsPage /></Suspense></AccessRoute>} />
        <Route path="/employees" element={<AccessRoute permission={["team.view", "team.manage", "team.operations.manage"]}><Suspense fallback={<PageLoader />}><EmployeesPage /></Suspense></AccessRoute>} />
        <Route path="/settings" element={<AccessRoute permission="settings.manage"><Suspense fallback={<PageLoader />}><SettingsPage /></Suspense></AccessRoute>} />
        <Route
          path="/:module"
          element={<Suspense fallback={<PageLoader />}><ModulePlaceholder /></Suspense>}
        />
      </Route>
    </Routes>;
}

function PageLoader() {
  return <div className="page-loader" aria-label="Загрузка"><span /></div>;
}
